import { http } from '../http';

export const createBasicAccountService = async (params) => {
  try {
    const response = await http.post('/user/basic_account', params);
    return response?.data;
  } catch (e) {
    console.error('something went wrong', e);
    return false;
  }
};

export default {
  createBasicAccountService,
};
